@if (isTestInstance()) {
  <div class="env-test-banner" role="status">
    <i class="fa-light fa-triangle-exclamation" aria-hidden="true"></i>
    <span>Vous travaillez sur l'environnement de test</span>
  </div>
}
@if (demoResetLabel()) {
  <aside class="demo-banner" role="status">
    <span class="demo-banner__dot" aria-hidden="true"></span>
    <span>
      <strong>Démonstration</strong> — les données sont fictives et remises à zéro
      automatiquement. Prochaine réinitialisation {{ demoResetLabel() }}.
    </span>
  </aside>
}
<p-toast position="top-right"></p-toast>
<app-loader></app-loader>
<app-nouvelle-version />
<router-outlet />
